export default __webpack_public_path__ + "static/media/mindannyiunkHangja.b68e91d9.png";